import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SaveUserSettingsPage } from './save-user-settings.page';

const routes: Routes = [
  {
    path: 'save-user-settings',
    component: SaveUserSettingsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SaveUserSettingsPageRoutingModule {}
